import {
    Box,
    Typography,
    FormControl,
    RadioGroup,
    FormControlLabel,
} from "@mui/material";
import CustomButton from "../../../UIElements/CustomButton";
import CancelModalButton from "../../../UIElements/CustomModal/CancelModalButton";
import { useState } from "react";
import { DossierDataToUpdate } from "../../../../types";

import CustomRadio from "../../../UIElements/CustomRadio";
import CustomAlert from "../../../UIElements/CustomAlert";

export default function DecisionFinalModalContent({
    firstDecision,
    statusFirstId,
    statusSecondeId,
    labelFirstRadio,
    labelSecondRadio,
    text,
    dataDossier,
    onSubmit,
}: {
    firstDecision: boolean;
    suspended: any;
    statusFirstId: number | undefined | null;
    statusSecondeId: number | undefined | null;
    labelFirstRadio: string;
    labelSecondRadio: string;
    text: string;
    dataDossier: DossierDataToUpdate;
    onSubmit: Function;
}) {
    const [comContent, setComContent] = useState("");
    const [selected, setSelected] = useState<number | undefined | null>(
        dataDossier.establishmentStatus
    );
    const [isDisabled, setIsDisabled] = useState(true);
    const title = firstDecision
        ? "Rendre une décision"
        : "Rendre une nouvelle décision";
    const preLabel = firstDecision ? "" : "Je souhaite :";
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "2rem",
                flex: "1 0 0",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "2rem",
                    alignSelf: "stretch",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "0.5rem",
                        alignSelf: "stretch",
                    }}
                >
                    <Typography
                        sx={{
                            color: "var(--Generiques-Dark-Blue-1, #023)",
                            fontFamily: "Roboto",
                            fontSize: "1.25rem",
                            fontStyle: "normal",
                            fontWeight: "700",
                            lineHeight: "normal",
                        }}
                    >
                        {title}
                    </Typography>
                    <Box
                        sx={{
                            display: "flex",
                            padding: "1rem",
                            alignItems: "center",
                            alignSelf: "stretch",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "0.75rem",
                                flex: "1 0 0",
                            }}
                        >
                            <CustomAlert
                                variant="filled"
                                severity="info"
                                label={text}
                                sx={{
                                    display: "flex",
                                    padding: "1rem",
                                    alignItems: "center",
                                    gap: "2rem",
                                    borderRadius: "0.75rem",
                                    border: "1px solid #0082DE",
                                    ".MuiAlert-icon": {
                                        width: "1.25rem",
                                        height: "1.25rem",
                                        color: "#0082DE",
                                    },
                                    ".MuiAlert-message": {
                                        fex: "1 0 0",
                                        color: "#023",
                                        fontFamily: "Roboto",
                                        fontSize: "0.875rem",
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        lineHeight: "120%",
                                    },
                                }}
                            />
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "1rem",
                        }}
                    >
                        <Typography
                            sx={{
                                color: "var(--Generiques-Dark-Blue-1, #023)",
                                fontFamily: "Roboto",
                                fontSize: "1rem",
                                fontStyle: "normal",
                                fontWeight: "500",
                                lineHeight: "normal",
                            }}
                        >
                            {preLabel}
                        </Typography>
                        <FormControl>
                            <RadioGroup
                                value={selected}
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                onChange={(e) => {
                                    setSelected(parseInt(e.target.value));
                                    setIsDisabled(false);
                                }}
                            >
                                <FormControlLabel
                                    value={statusFirstId}
                                    control={<CustomRadio />}
                                    label={labelFirstRadio}
                                />
                                <FormControlLabel
                                    value={statusSecondeId}
                                    control={<CustomRadio />}
                                    label={labelSecondRadio}
                                />
                            </RadioGroup>
                        </FormControl>
                    </Box>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",

                        gap: "1rem",
                        alignSelf: "stretch",
                    }}
                >
                    <div
                        style={{
                            // width: "100%",
                            height: "100%",
                            flexDirection: "column",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            display: "inline-flex",
                        }}
                    >
                        <div
                            style={{
                                alignSelf: "stretch",
                                justifyContent: "flex-start",
                                alignItems: "flex-start",
                                gap: 4,
                                display: "inline-flex",
                            }}
                        >
                            <div
                                style={{
                                    color: "#002233",
                                    fontSize: "0.875rem",
                                    fontFamily: "Roboto",
                                    fontWeight: "500",
                                    lineHeight: "1.4rem",
                                    wordWrap: "break-word",
                                }}
                            >
                                Commentaire
                            </div>
                            <div
                                style={{
                                    flex: "1 1 0",
                                    color: "#002233",
                                    fontSize: "0.875rem",
                                    fontFamily: "Roboto",
                                    fontStyle: "italic",
                                    fontWeight: "400",
                                    lineHeight: "1.365rem",
                                    wordWrap: "break-word",
                                }}
                            >
                                (Facultatif)
                            </div>
                        </div>
                    </div>
                    <div
                        style={{
                            height: "100%",
                            padding: "1.0625rem 1rem",
                            background: "white",
                            borderRadius: "1rem",
                            border: "2px #E3E6E8 solid",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: "0.5rem",
                            display: "inline-flex",
                        }}
                    >
                        <textarea
                            value={comContent}
                            onChange={(e) => setComContent(e.target.value)}
                            name="comment"
                            style={{
                                resize: "none",
                                flex: "1 1 0",
                                color: "#002233",
                                fontSize: "1rem",
                                fontFamily: "Roboto",
                                fontWeight: "400",
                                fontStyle: "normal",
                                lineHeight: "1.6rem",
                                wordWrap: "break-word",
                                border: "none",
                                outline: "none",
                            }}
                        ></textarea>
                    </div>
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "1rem",
                        alignSelf: "stretch",
                    }}
                >
                    <CustomButton
                        onClick={async () => {
                            const comment = document.querySelector(
                                "textarea[name='comment']"
                            );
                            if (comment) {
                                dataDossier.assignedValidatorComment =
                                    comContent;
                            }
                            if (selected) {
                                dataDossier.establishmentStatus = selected;
                            }
                            onSubmit(dataDossier);
                            setIsDisabled(true);
                        }}
                        disabled={isDisabled}
                        label="Validez l'avis"
                        customsx={{
                            width: "100%",
                        }}
                    />
                    <CancelModalButton
                        customsx={{
                            width: "100%",
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
}
